import * as React from "react";
import * as ReactDOM from "react-dom";
import * as moment from "moment";
import * as modelsGet from "../../models/get";
import * as modelsCalendar from "../../models/calendar";
import { getLockPosition } from "../../utils/calendar";
import { OptionalLink } from "../optionalLink";

interface IProperties
{
    /**
     * Wenn angegeben, wird hiermit das zugrunde liegende DOM-Element ermittelt.
     */
    appointmentRef?: (ref: HTMLAnchorElement) => void,

    /**
     * Inline-Style.
     */
    style?: React.CSSProperties,

    /**
     * Der Termin der gerendert werden soll.
     */
    appointment?: modelsCalendar.IAvailableAppointment,

    /**
     * Angabe, ob die Position des DOM-Elements "absolute" ist.
     */
    isPositionAbsolute?: boolean,

    /**
     * Wird ausgeführt, sobald auf das Item geklickt wird.
     */
    onClick?: (appointment: modelsCalendar.IAvailableAppointment) => void
}

export class OccupiedAppointment extends React.Component<IProperties>
{
    /**
     * Standardwerte setzen.
     */
    public static defaultProps: Partial<IProperties> = {
        isPositionAbsolute: true
    };

    /**
     * Führt die "onClick" Eigenschaft aus wenn diese gesetzt wurde.
     * @param e Das auslösende Ereignis.
     */
    private onClick = (e: React.MouseEvent<HTMLElement>) =>
    {
        var { appointment, onClick } = this.props;
        onClick && onClick(appointment);
    }

    /**
     * Rendert die Komponente.
     */
    public render(): JSX.Element
    {
        var {
            appointmentRef,
            style,
            appointment,
            isPositionAbsolute
        } = this.props;

        if (appointment != null)
        {
            var blockPosition = getLockPosition(appointment);
            var absolute: React.CSSProperties;
            if (isPositionAbsolute)
            {
                absolute = {
                    position: "absolute"
                }
            }

            return (
                <OptionalLink
                    anchorRef={appointmentRef}
                    className="lock lock--is-disabled"
                    style={{
                        ...blockPosition,
                        ...absolute,
                        ...style
                    }}>
                    <div className="lock_header-container">
                        <span className="lock_header">
                            {appointment.isForCompleteAppointment ? "Nicht verfügbar" : "Belegt"}
                        </span>
                    </div>
                </OptionalLink>
            );
        }
        else
        {
            return null;
        }
    }
}